import React, { useState, useEffect } from "react";

import { useLocation, useParams } from "react-router-dom";

import Menu from "../../../components/member/parts/Menu.js";
import Header from "../../../components/member/parts/Header.js";

import useMailTemplateState from "./useMailTemplateState.ts";
import useAuthState from "../../../auth/useAuthState.js";
import MailTemplateUpdateForm, { MailTemplateUpdateFormParams } from "./MailTemplateUpdateForm.ts";
import MailTemplateTestForm, { MailTemplateTestFormParams } from "./MailTemplateTestForm.ts";
import { via_types } from "../../../via/ViaConstants.ts";

//import "../styles/dashboard.css";
//import "../../../styles/customer.css";

function MailTemplateDetailApp() {
    const { accommodation_id } = useParams();
    const { id } = useParams();
    const location = useLocation();
    const isCreateMode = id === "create" || location.pathname.endsWith("/mail/template/create");
    const { token, getToken } = useAuthState();
    const { mail_template_item, getMailTemplateDetail, createMailTemplate, updateMailTemplate, sendTestMail } = useMailTemplateState();
    const [form, setForm] = useState<MailTemplateUpdateForm | null>(null);
    const [isEditing, setIsEditing] = useState<boolean>(false);
    const [showTestPopup, setShowTestPopup] = useState<boolean>(false);
    const [testForm, setTestForm] = useState<MailTemplateTestForm>(new MailTemplateTestForm());

    useEffect(() => {
        if (isCreateMode) {
            return;
        }
        if (mail_template_item) {
            // mail_template_itemが読み込まれたらフォームを初期化
            const initialForm = new MailTemplateUpdateForm({
                body: mail_template_item.body,
                title: mail_template_item.title,
                from_address: mail_template_item.from_address,
                from_name: mail_template_item.from_name,
            });
            setForm(initialForm);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mail_template_item, isCreateMode]);

    useEffect(() => {
        if (isCreateMode) {
            setForm(new MailTemplateUpdateForm({ send_type: 0 }));
            setIsEditing(true);
        }
    }, [isCreateMode]);

    useEffect(() => {
        if (isCreateMode && mail_template_item && mail_template_item.id) {
            window.location.href = "/m/accommodation/" + accommodation_id + "/mail/template/" + mail_template_item.id;
        }
    }, [isCreateMode, mail_template_item, accommodation_id]);

    useEffect(() => {
        if (isCreateMode) {
            return;
        }
        if (token && accommodation_id && id) {
            getMailTemplateDetail(token, accommodation_id, id);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token, isCreateMode]);

    useEffect(() => {
        getToken();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleInputChange = (field: keyof MailTemplateUpdateFormParams, value: string) => {
        if (form) {
            const updatedForm = form.set(field, value);
            setForm(updatedForm);
        }
    };

    const handleSubmit = () => {
        if (form) {
            try {
                if (isCreateMode) {
                    createMailTemplate(token!, accommodation_id!, form);
                    return;
                }
                updateMailTemplate(token!, accommodation_id!, id!, form);
                setIsEditing(false);
            } catch (error) {
                console.error("Form validation failed:", error);
                alert("入力内容に問題があります: " + (error as Error).message);
            }
        }
    };

    const handleEdit = () => {
        setIsEditing(true);
    };

    const handleCancel = () => {
        if (isCreateMode) {
            window.location.href = "/m/accommodation/" + accommodation_id + "/mail/template";
            return;
        }
        if (mail_template_item && form) {
            // 元のデータに戻す
            const resetForm = new MailTemplateUpdateForm({
                body: mail_template_item.body,
                title: mail_template_item.title,
                from_address: mail_template_item.from_address,
                from_name: mail_template_item.from_name,
            });
            setForm(resetForm);
            setIsEditing(false);
        }
    };

    const handleTestSend = () => {
        setShowTestPopup(true);
    };

    const handleTestFormSubmit = () => {
        if (testForm && token && accommodation_id && id) {
            console.log("テスト送信:", testForm);
            try {
                sendTestMail(token, accommodation_id, id, testForm);
                setShowTestPopup(false);
            } catch (error) {
                console.error("Test form validation failed:", error);
                alert("入力内容に問題があります: " + (error as Error).message);
            }
        }
    };

    const handleTestFormCancel = () => {
        setShowTestPopup(false);
        setTestForm(new MailTemplateTestForm()); // フォームをリセット
    };

    const handleTestInputChange = (field: keyof MailTemplateTestFormParams, value: string | number) => {
        const updatedForm = testForm.set(field, value);
        setTestForm(updatedForm);
    };

    return (
        <div className="inner">
            <main className="main">
                <Menu selected="accommodation" accommodation_id={accommodation_id} />
                <div className="main-content">
                    <Header accommodation_id={accommodation_id} id="calendar" />
                    <div className="free-pannel scrollable-vertical">
                        <section className="pannel">
                            <div className="section-header">
                                <div className="title">{isCreateMode ? "メールテンプレート作成" : "メールテンプレート詳細"}</div>
                                <div className="select"></div>
                                <div className="right-menu">
                                    {!isCreateMode && !isEditing ? (
                                        <div>
                                            <button
                                                onClick={handleEdit}
                                                style={{
                                                    marginRight: "10px",
                                                    padding: "2px 12px",
                                                    border: "none",
                                                    backgroundColor: "#007bff",
                                                    color: "white",
                                                    borderRadius: "4px",
                                                    cursor: "pointer",
                                                    fontSize: "14px",
                                                    height: "32px",
                                                    fontWeight: 500,
                                                }}
                                            >
                                                編集
                                            </button>
                                            <button
                                                onClick={handleTestSend}
                                                style={{
                                                    padding: "2px 12px",
                                                    border: "1px solid #28a745",
                                                    backgroundColor: "#28a745",
                                                    color: "white",
                                                    borderRadius: "4px",
                                                    cursor: "pointer",
                                                    fontSize: "14px",
                                                    height: "32px",
                                                    fontWeight: 500,
                                                }}
                                            >
                                                テスト送信
                                            </button>
                                        </div>
                                    ) : (
                                        <div>
                                            <button
                                                onClick={handleSubmit}
                                                style={{
                                                    marginRight: "10px",
                                                    padding: "2px 12px",
                                                    border: "none",
                                                    backgroundColor: "#28a745",
                                                    color: "white",
                                                    borderRadius: "4px",
                                                    cursor: "pointer",
                                                    fontSize: "14px",
                                                    height: "32px",
                                                    fontWeight: 500,
                                                }}
                                            >
                                                保存
                                            </button>
                                            <button
                                                onClick={handleCancel}
                                                style={{
                                                    padding: "2px 12px",
                                                    border: "1px solid #6c757d",
                                                    backgroundColor: "#6c757d",
                                                    color: "white",
                                                    borderRadius: "4px",
                                                    cursor: "pointer",
                                                    fontSize: "14px",
                                                    height: "32px",
                                                    fontWeight: 500,
                                                }}
                                            >
                                                キャンセル
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </div>

                            {form && (
                                <div className="form-container" style={{ padding: "20px" }}>
                                    <div className="form-group" style={{ marginBottom: "20px" }}>
                                        <label htmlFor="title" style={{ display: "block", marginBottom: "5px", fontWeight: "bold", fontSize: "12px" }}>
                                            タイトル <span style={{ color: "red" }}>*</span>
                                        </label>
                                        {isEditing ? (
                                            <input
                                                id="title"
                                                type="text"
                                                value={form.title || ""}
                                                onChange={(e) => handleInputChange("title", e.target.value)}
                                                style={{
                                                    width: "100%",
                                                    padding: "8px",
                                                    border: "1px solid #ccc",
                                                    borderRadius: "4px",
                                                    fontSize: "14px",
                                                }}
                                            />
                                        ) : (
                                            <div style={{ padding: "8px", backgroundColor: "#f8f9fa", border: "1px solid #e9ecef", borderRadius: "4px" }}>
                                                {form.title || "未設定"}
                                            </div>
                                        )}
                                    </div>

                                    <div className="form-group" style={{ marginBottom: "20px" }}>
                                        <label htmlFor="from_name" style={{ display: "block", marginBottom: "5px", fontWeight: "bold", fontSize: "12px" }}>
                                            送信者名 <span style={{ color: "red" }}>*</span>
                                        </label>
                                        {isEditing ? (
                                            <input
                                                id="from_name"
                                                type="text"
                                                value={form.from_name || ""}
                                                onChange={(e) => handleInputChange("from_name", e.target.value)}
                                                style={{
                                                    width: "100%",
                                                    padding: "8px",
                                                    border: "1px solid #ccc",
                                                    borderRadius: "4px",
                                                    fontSize: "14px",
                                                }}
                                            />
                                        ) : (
                                            <div style={{ padding: "8px", backgroundColor: "#f8f9fa", border: "1px solid #e9ecef", borderRadius: "4px" }}>
                                                {form.from_name || "未設定"}
                                            </div>
                                        )}
                                    </div>

                                    <div className="form-group" style={{ marginBottom: "20px" }}>
                                        <label htmlFor="from_address" style={{ display: "block", marginBottom: "5px", fontWeight: "bold", fontSize: "12px" }}>
                                            送信メールアドレス <span style={{ color: "red" }}>*</span>
                                        </label>
                                        {isEditing ? (
                                            <input
                                                id="from_address"
                                                type="email"
                                                value={form.from_address || ""}
                                                onChange={(e) => handleInputChange("from_address", e.target.value)}
                                                style={{
                                                    width: "100%",
                                                    padding: "8px",
                                                    border: "1px solid #ccc",
                                                    borderRadius: "4px",
                                                    fontSize: "14px",
                                                }}
                                            />
                                        ) : (
                                            <div style={{ padding: "8px", backgroundColor: "#f8f9fa", border: "1px solid #e9ecef", borderRadius: "4px" }}>
                                                {form.from_address || "未設定"}
                                            </div>
                                        )}
                                    </div>

                                    <div className="form-group" style={{ marginBottom: "20px" }}>
                                        <label htmlFor="body" style={{ display: "block", marginBottom: "5px", fontWeight: "bold", fontSize: "12px" }}>
                                            メール本文
                                        </label>
                                        {isEditing ? (
                                            <textarea
                                                id="body"
                                                value={form.body || ""}
                                                onChange={(e) => handleInputChange("body", e.target.value)}
                                                rows={15}
                                                style={{
                                                    width: "100%",
                                                    padding: "8px",
                                                    border: "1px solid #ccc",
                                                    borderRadius: "4px",
                                                    fontSize: "14px",

                                                    resize: "vertical",
                                                    minHeight: "400px",
                                                }}
                                            />
                                        ) : (
                                            <div
                                                style={{
                                                    padding: "8px",
                                                    backgroundColor: "#f8f9fa",
                                                    border: "1px solid #e9ecef",
                                                    borderRadius: "4px",
                                                    minHeight: "400px",
                                                    whiteSpace: "pre-wrap",
                                                }}
                                            >
                                                {form.body || "未設定"}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}
                        </section>
                    </div>
                </div>
            </main>

            {/* テスト送信ポップアップ */}
            {showTestPopup && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 1000,
                    }}
                >
                    <div
                        style={{
                            backgroundColor: "white",
                            padding: "30px",
                            borderRadius: "8px",
                            width: "500px",
                            maxWidth: "90%",
                            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                        }}
                    >
                        <h3 style={{ marginBottom: "20px", fontSize: "18px", fontWeight: "bold" }}>テスト送信</h3>

                        <div className="form-group" style={{ marginBottom: "20px" }}>
                            <label htmlFor="mail_address" style={{ display: "block", marginBottom: "5px", fontWeight: "bold", fontSize: "12px" }}>
                                送信先メールアドレス
                            </label>
                            <input
                                type="email"
                                id="mail_address"
                                value={testForm.mail_address || ""}
                                onChange={(e) => handleTestInputChange("mail_address", e.target.value)}
                                style={{
                                    width: "100%",
                                    padding: "8px",
                                    border: "1px solid #ccc",
                                    borderRadius: "4px",
                                    fontSize: "14px",
                                }}
                                placeholder="test@example.com"
                            />
                        </div>

                        <div className="form-group" style={{ marginBottom: "20px" }}>
                            <label htmlFor="via" style={{ display: "block", marginBottom: "5px", fontWeight: "bold", fontSize: "12px" }}>
                                予約経路
                            </label>
                            <select
                                id="via"
                                value={testForm.via ?? ""}
                                onChange={(e) => handleTestInputChange("via", parseInt(e.target.value))}
                                style={{
                                    width: "100%",
                                    padding: "8px",
                                    border: "1px solid #ccc",
                                    borderRadius: "4px",
                                    fontSize: "14px",
                                }}
                            >
                                <option value="">選択してください</option>
                                {via_types.map((type) => (
                                    <option key={type.value} value={type.value}>
                                        {type.label}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
                            <button
                                onClick={handleTestFormCancel}
                                style={{
                                    padding: "10px 20px",
                                    border: "1px solid #6c757d",
                                    backgroundColor: "#6c757d",
                                    color: "white",
                                    borderRadius: "4px",
                                    cursor: "pointer",
                                    fontSize: "14px",
                                }}
                            >
                                キャンセル
                            </button>
                            <button
                                onClick={handleTestFormSubmit}
                                style={{
                                    padding: "10px 20px",
                                    border: "none",
                                    backgroundColor: "#28a745",
                                    color: "white",
                                    borderRadius: "4px",
                                    cursor: "pointer",
                                    fontSize: "14px",
                                }}
                                disabled={!testForm.mail_address || testForm.via === null}
                            >
                                送信
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default MailTemplateDetailApp;
